import { render, staticRenderFns } from "./RqtaEditMain.vue?vue&type=template&id=cae38976&scoped=true&"
import script from "./RqtaEditMain.vue?vue&type=script&lang=js&"
export * from "./RqtaEditMain.vue?vue&type=script&lang=js&"
import style0 from "./RqtaEditMain.vue?vue&type=style&index=0&id=cae38976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae38976",
  null
  
)

export default component.exports